import './Interested.css';
import React from 'react';
import Contact from '../contact/Contact';
import WaitlistButton from '../waitlist/WaitlistButton';

function Interested({showGraphic, showContactUs = false}) {
  return (
    <section className={showGraphic === true ? 'interested graphic' : 'interested'}>
      <div className={showGraphic === true ? 'white center' : 'center'}>
        {showContactUs ? (
          <React.Fragment>
            <p className='title'>Get in touch.</p>
            <p>Contact us with any questions or suggestions.</p>
            <Contact showButton={true} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <p className='title'>Interested? Join the waitlist now</p>
            <p>We&apos;ll email you once our product becomes available.</p>
            <WaitlistButton />
            <p className='subtitle'>Financial freedom. Simplified.</p>
          </React.Fragment>
        )}
      </div>
    </section>
  );
};

export default Interested;